import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const UpdateLabel = styled.label`
  font-weight: bold;
  margin-bottom: 8px;
`;

export const UpdateInput = styled.input`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
`;

export const UpdateTextarea = styled.textarea`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
  resize: vertical;
`;

export const UpdateCheckbox = styled.input.attrs({ type: 'checkbox' })`
  margin-top: 6px;
`;

export const UpdateError = styled.span`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;